import { StandardPageLayout } from "components/layouts/standard-page-layout";
import { Database } from "lucide-react";
import { HomeEditActions } from "./home-edit-actions";
import { HomeGrid } from "./home-grid";
import { HomeLayoutProvider } from "./home-layout-context";
import { AnnouncementBanner } from "./announcement-banner";

export const HubPage = () => {
  return (
    <HomeLayoutProvider>
      <StandardPageLayout
        pageTitle={{
          icon: Database,
          title: "Welcome to Geoscape Hub",
          description:
            "Your central hub for accessing, clipping, and integrating Geoscape data. Get started with quick actions below or explore the sidebar navigation.",
          actions: <HomeEditActions />,
        }}
      >
        <AnnouncementBanner />
        <HomeGrid />
      </StandardPageLayout>
    </HomeLayoutProvider>
  );
};
